import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-paging-viewer',
    templateUrl: './paging-viewer.component.html',
    styleUrls: [
        './paging-viewer.component.scss'
    ],
    standalone: false
})
export class PagingViewerComponent
{
    @Input() first: number;
    @Input() last: number;
    @Input() total: number;
    @Input() loaded: number;
}
